export default "__VITE_ASSET__Cb4f3OtL__";